export enum UserPreferences {
  PLANNING = 'PLANNING',
  SCREENER_PLANNING = 'SCREENER_PLANNING',
  noShowAgainScreenerPlanningModal = 'noShowAgainScreenerPlanningModal',
}
